<template>
  <div class="content">
    <p>{{$t('selectlanguages.title')}}</p>
    <base-button
      @click="addToSelectedLanguages('Albanian')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Albanian'),
      }"
      >Albanian</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Arabic')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Arabic') }"
      >Arabic</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Bengali')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Bengali') }"
      >Bengali</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Cebuano')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Cebuano') }"
      >Cebuano</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Chinese')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Chinese') }"
      >Chinese</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Danish')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Danish') }"
      >Danish</base-button
    >
    <base-button
      @click="addToSelectedLanguages('English')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('English') }"
      >English</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Filipino')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Filipino'),
      }"
      >Filipino</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Finnish')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Finnish') }"
      >Finnish</base-button
    >
    <base-button
      @click="addToSelectedLanguages('French')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('French') }"
      >French</base-button
    >
    <base-button
      @click="addToSelectedLanguages('German')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('German') }"
      >German</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Greek')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Greek') }"
      >Greek</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Hindi')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Hindi') }"
      >Hindi</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Icelandic')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Icelandic'),
      }"
      >Icelandic</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Iloko')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Iloko') }"
      >Iloko</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Indonesian')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Indonesian'),
      }"
      >Indonesian</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Japanese')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Japanese'),
      }"
      >Japanese</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Korean')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Korean') }"
      >Korean</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Malay')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Malay') }"
      >Malay</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Mongolian')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Mongolian'),
      }"
      >Mongolian</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Norwegian')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Norwegian'),
      }"
      >Norwegian</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Russian')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Russian') }"
      >Russian</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Swedish')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Swedish') }"
      >Swedish</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Thai')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Thai') }"
      >Thai</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Turkish')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Turkish') }"
      >Turkish</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Vietnamese')"
      :class="{
        grey: this.$store.state.selectedLanguages.includes('Vietnamese'),
      }"
      >Vietnamese</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Persian')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Persian') }"
      >Persian</base-button
    >
    <base-button
      @click="addToSelectedLanguages('Urdu')"
      :class="{ grey: this.$store.state.selectedLanguages.includes('Urdu') }"
      >Urdu</base-button
    >
    <div class="ErrorMessage">
      <p1 v-if="!isPageValid">Please select at least a language!</p1>
    </div>
    <br />
    <base-button class="button-process" @click="navigateNextPage"
      >{{$t('proceed')}}</base-button
    >
  </div>

  <div class="pagenumber">
    <label>3/7</label>
  </div>
</template>

<script>
export default {
  data() {
    this.$store.state.selectedLanguages = [];
    return {
      isPageValid: true,
    };
  },
  methods: {
    navigateNextPage() {
      console.log(
        'Selected Language is : ' +
          this.$store.state.selectedLanguages +
          ' Size: ' +
          this.$store.state.selectedLanguages.length
      );
      if (this.$store.state.selectedLanguages.length < 1) {
        this.isPageValid = false;
      } else {
        this.isPageValid = true;
        this.$router.push('/personaldescriptions');
      }
    },
    addToSelectedLanguages(data) {
      if (!this.$store.state.selectedLanguages.includes(data)) {
        this.$store.state.selectedLanguages.push(data);
        console.log(
          'Selected Languages are : ' + this.$store.state.selectedLanguages
        );
      } else {
        this.$store.state.selectedLanguages.splice(
          this.$store.state.selectedLanguages.indexOf(data),
          1
        );
        console.log(
          'Selected Languages are : ' + this.$store.state.selectedLanguages
        );
      }
    },
  },
};
</script>

<style scoped>
.grey {
  background-color: grey;
}
button,
a {
  font-size: 14px;
  padding: 0.8rem 1.5rem;
  margin-left: 10px;
  margin-bottom: 10px;
  width: 150px;
}
div.content {
  width: 1200px;
}
</style>
